/**
 * @generated SignedSource<<97f1e9b3fed7d644c6c475e3944c775e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type reportImage_reportsOverviewPage$data = {
  readonly imageUrl: string | null | undefined;
  readonly key: string;
  readonly name: string;
  readonly " $fragmentType": "reportImage_reportsOverviewPage";
};
export type reportImage_reportsOverviewPage$key = {
  readonly " $data"?: reportImage_reportsOverviewPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"reportImage_reportsOverviewPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "reportImage_reportsOverviewPage",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "key"
      },
      "action": "THROW",
      "path": "key"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "name"
      },
      "action": "THROW",
      "path": "name"
    },
    {
      "kind": "ScalarField",
      "name": "imageUrl"
    }
  ],
  "type": "JiraReport"
};

(node as any).hash = "1bc97c3705a9a5fa1d99b4071832ba2a";

export default node;
